import { Box } from "@theme/components/ThemeUi";

import type { ThemeUIStyleObject } from "@theme/components/ThemeUi";
import type { ElementType, FC } from "react";

export interface SpacerProps {
  direction?: "horizontal" | "vertical" | Array<"horizontal" | "vertical">;
  space?: number | string | Array<number | string | null>;
  as?: ElementType;
  sx?: ThemeUIStyleObject;
  className?: string;
}

export const Spacer: FC<SpacerProps> = ({
  space = "s400",
  direction = "vertical",
  as = "div",
  sx,
  className,
}) => (
  <Box
    mt={direction === "vertical" ? space : 0}
    mr={direction === "horizontal" ? space : 0}
    as={as}
    sx={sx}
    className={className}
  />
);
